import { Event } from '@app/objects/Event';
import eventDate from '@app/utils/eventDate';

export const addEvents = (events: Array<Event>) => {
	return events.map((event) => {
		const dateFrom = event.dateFrom !== null && new Date(event.dateFrom);
		const dateTo = event.dateTo !== null && new Date(event.dateTo);

		return {
			date: eventDate(dateFrom, dateTo),
			text: event.name,
			link: event.url ? event.url : '',
			location: event.place ? event.place : '',
		};
	});
};
